mainApp.component('floatingIps', {
    templateUrl: '/public/components/floatingIps.html',
    bindings: {
        floatingIps: '=',
        deleteItems: '&',
        changesListener: '&'
    },
    controller: floatingIpsController
});

function floatingIpsController($scope, GeneralUtilsService) {
    var $ctrl = this;

    $ctrl.$onInit = function(){
        //save original copy to compare and find changes
        $ctrl.original = angular.copy($ctrl.floatingIps);

        $ctrl.propertiesModified = false;
        $ctrl.hasChanges = false;
    }

    //check if changes were made to update changesListener
    $ctrl.$doCheck = function() {
            if (!$ctrl.changesListener)
                return;

            var isChangedNow = !angular.equals($ctrl.floatingIps, $ctrl.original);

        //check if listener was already called and updates about having changes
            if ($ctrl.hasChanges === isChangedNow)
                return;

            $ctrl.hasChanges = isChangedNow;
            $ctrl.changesListener({isDirty: $ctrl.hasChanges, componentName: 'floatingIps'});
        }

    //if account was reloaded - notify the table to reload data and save original state again to compare changes
    $scope.$on('modelReloadedEvent', function (event, data) {
           $ctrl.original = angular.copy($ctrl.floatingIps);
           $ctrl.tableDataModified = new Date().getTime();
       });

    $ctrl.floatingIpsTableConfig = {
        id: "floatingIps",
        dataURL : function (){return null;},
        selectedItems: [],
        actions: [],
        fields: [{ label: 'Name', path: 'floatingRangeName', template: "<span><input type='text' class='form-control' ng-model='item.floatingRangeName' /></span>" },
                  { label: 'IP Range', path: 'subnet', template: "<span><input type='text' class='form-control' ng-model='item.subnet' placeholder='e.g. 10.0.0.0/24'></span>" }],
        addAction: function() {
            var newItem = {id:GeneralUtilsService.getRandomId(),name:""};
            this.items.push(newItem);
            $ctrl.tableDataModified = new Date().getTime();
         },
         parseData: function(){
           return $ctrl.floatingIps;
         },
         specialActions:[{
             func: function(selectedItems) {
                 var itemsToDelete = [];

                   selectedItems.forEach(function(item) {
                     for (var i = 0 ; i < $ctrl.floatingIps.length; i++) {
                         var ipRange = $ctrl.floatingIps[i];
                         if (item.id === ipRange.id) {
                             $ctrl.floatingIps.splice(i, 1);
                             if (item.id > 0) {
                             itemsToDelete.push(ipRange);
                                 break;
                              }
                         }
                     }
                 });
                 $ctrl.deleteItems({items: itemsToDelete, propertyName: 'floatingIps'});
                 $ctrl.tableDataModified = new Date().getTime();
             },
             icon: "delete",
             tooltip: "Delete"}
         ],
        titleSearch : true,
        clientSideSort: true,
        clientSideSearch: true,
        keepPageOnRefresh: true,
        clientSidePaging: true

    }
}